import { computed, observable } from 'mobx'

import { Entity } from 'shared/stores/BaseStore'

import { TicketDTO, TicketHistoryDTO, TicketStatus, TicketSupportLogsDTO } from '../../types'

export class Ticket extends Entity {
  @observable userId = 0
  @observable createDate: string = ''
  @observable finishDate: string = ''
  @observable description: string = ''
  @observable imageUrls: string[] = []
  @observable videoUrls: string[] = []
  @observable documentUrls: string[] = []
  @observable ticketTypeId = 0
  @observable ticketTypeName: string = ''
  @observable status = TicketStatus.open
  @observable supportLogs: TicketSupportLogsDTO[] = []
  @observable ticketHistory: TicketHistoryDTO[] = []
  @observable ticketGrade = 0
  @observable gradeComment = ''
  @observable openAfterAnswer = 0
  @observable isRead = false
  @observable managerId = 0
  @observable updateDate: string = ''
  @observable orderId = 0
  @observable autoClose = 0

  /* Здесь перечислены свойства, которых нет в DTO модели */
  constructor(props: Omit<Ticket, 'canRate' | 'hasManagerComment' | 'hasNotice'>) {
    super(props)
    Object.assign(this, props)
  }

  static create({ ...data }: TicketDTO) {
    return new Ticket({
      ...data,
      videoUrls: data.videoUrls ?? [],
      imageUrls: data.imageUrls ?? [],
      documentUrls: data.documentUrls ?? [],
      status: data.ticketStateId,
    })
  }

  @computed
  get hasManagerComment() {
    return this.supportLogs.some((log) => log.isManager)
  }

  get canRate() {
    return this.status === TicketStatus.closed && !this.ticketGrade && this.hasManagerComment && !this.autoClose
  }

  @computed
  get hasNotice() {
    return this.status === TicketStatus.inProgress && this.supportLogs[this.supportLogs.length - 1]?.isManager
  }
}
